// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * User Edit Modal Styles
 * Clean, responsive styles with proper scrolling
 */

/* Modal Overlay - Now using global styles from design-system.css */

/* Modal Container - Now using global styles from design-system.css */

/* Modal Header - Now using global styles from design-system.css */

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-btn:hover:not(:disabled) {
  background: #e9ecef;
  color: #333;
}

.close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Modal Body - Now using global styles from design-system.css */

/* Form Sections */
.form-section {
  margin-bottom: 24px;
}

.form-section:last-of-type {
  margin-bottom: 0;
}

.form-section h3 {
  margin: 0 0 16px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
}

/* Form Rows */
.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.form-row:last-child {
  margin-bottom: 0;
}

/* Form Groups */
/* Form Groups - Now using global styles from design-system.css */

.form-group input:disabled {
  background: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}

/* Checkbox Group */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #333;
  -webkit-user-select: none;
          user-select: none;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #e9ecef;
  border-radius: 4px;
  background: white;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-label input[type="checkbox"]:checked+.checkmark {
  background: #0D3B66;
  border-color: #0D3B66;
}

.checkbox-label input[type="checkbox"]:checked+.checkmark::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.checkbox-label input[type="checkbox"]:disabled+.checkmark {
  background: #f8f9fa;
  border-color: #dee2e6;
  cursor: not-allowed;
}

/* Error Messages */
.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 0.9rem;
}

.field-error {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
}

/* Modal Footer - Now using global styles from design-system.css */

/* Buttons - Now using global styles from design-system.css */

/* Responsive Design */
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
  }

  .form-row:first-child {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-container {
    max-height: 95vh;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-header h2 {
    font-size: 1.3rem;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-footer {
    padding: 12px 16px;
  }

  .form-section {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/users/UserEditModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mEAAmE;;AAEnE,qEAAqE;;AAErE,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gEAAgE;;AAEhE,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB,iEAAiE;;AAEjE;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kEAAkE;;AAElE,6DAA6D;;AAE7D,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/**\n * User Edit Modal Styles\n * Clean, responsive styles with proper scrolling\n */\n\n/* Modal Overlay - Now using global styles from design-system.css */\n\n/* Modal Container - Now using global styles from design-system.css */\n\n/* Modal Header - Now using global styles from design-system.css */\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover:not(:disabled) {\n  background: #e9ecef;\n  color: #333;\n}\n\n.close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Modal Body - Now using global styles from design-system.css */\n\n/* Form Sections */\n.form-section {\n  margin-bottom: 24px;\n}\n\n.form-section:last-of-type {\n  margin-bottom: 0;\n}\n\n.form-section h3 {\n  margin: 0 0 16px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n/* Form Rows */\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Form Groups */\n/* Form Groups - Now using global styles from design-system.css */\n\n.form-group input:disabled {\n  background: #f8f9fa;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Checkbox Group */\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #333;\n  user-select: none;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkmark {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e9ecef;\n  border-radius: 4px;\n  background: white;\n  position: relative;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark {\n  background: #0D3B66;\n  border-color: #0D3B66;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark::after {\n  content: '✓';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.checkbox-label input[type=\"checkbox\"]:disabled+.checkmark {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n  cursor: not-allowed;\n}\n\n/* Error Messages */\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 0.9rem;\n}\n\n.field-error {\n  color: #dc3545;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n/* Modal Footer - Now using global styles from design-system.css */\n\n/* Buttons - Now using global styles from design-system.css */\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .form-row:first-child {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .modal-container {\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header {\n    padding: 12px 16px;\n  }\n\n  .modal-body {\n    padding: 16px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n  }\n\n  .form-section {\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
